import { InputField } from "../AddPatientGroup.style";
import * as React from "react";
import { useTranslation } from "hhn-commons";
import { errorsType } from "../PatientGroupUtils";

type InputMedicalRecordNumberProps = {
  patientInfoData: any;
  onFormDataChange: (key: string, value: string) => void;
  onSetErrors: (key: string, value: boolean) => void;
  errors: errorsType;
  required: boolean;
};
export const InputMedicalRecordNumber = ({
  patientInfoData,
  onFormDataChange,
  onSetErrors,
  errors,
  required,
}: InputMedicalRecordNumberProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });

  return (
    <InputField
      required={required}
      id="mrn-field"
      label={tNs("mrnLabel")}
      type="text"
      variant="standard"
      onBlur={e => {
        if (!required) return;
        onSetErrors("mrn", e.target.value.trim().length <= 0);
      }}
      error={errors.mrn}
      value={patientInfoData.mrn}
      onChange={e => {
        const mrn: string = e.target.value;
        onFormDataChange("mrn", mrn);
        if (required) {
          onSetErrors("mrn", mrn.trim().length <= 0);
        }
      }}
      helperText={errors.mrn ? tNs("invalidMrn") : " "}
      slotProps={{
        inputLabel: { shrink: !!patientInfoData.mrn },
        htmlInput: { "data-testid": "mrn-field", maxLength: 25 },
      }}
    />
  );
};
